import { BookingStatusMap } from "utils/interfaces"

export const CANCELED_STATUSES = [
    BookingStatusMap.CANCELLED,
    BookingStatusMap.CANCELLED_WITHOUT_REFUND,
    BookingStatusMap.CANCELLED_AFTER_PAYMENT,
]
export const UNPAID_STATUSES = [
    BookingStatusMap.NOT_PAID,
    BookingStatusMap.PAY_STARTED,
    BookingStatusMap.PAY_ERROR,
]
export const PAID_STATUSES = [BookingStatusMap.PAID, BookingStatusMap.PAID_AFTER_CANCELLATION]
